type VatCode = {
  id: string;
  code?: string;
  label: string;
  scope?: 'unknown' | 'nat' | 'eu' | 'int';
  rate: number;
  type: 'unknown' | 'sale' | 'purchase' | 'both';
  deductible_account?: string;
  payable_account?: string;
};

enum JournalTypes {
  unknown = 'unknown',
  customer_invoice = 'customer_invoice',
  customer_refund = 'customer_refund',
  supplier_invoice = 'supplier_invoice',
  supplier_refund = 'supplier_refund',
  financial_operation = 'financial_operation',
  miscellaneous_operation = 'miscellaneous_operation',
}

type Journal = {
  id: string;
  code?: string;
  name: string;
  type: JournalTypes;
  journal_type: JournalTypes;
};

type FolderData = {
  vatCodes: VatCode[];
  journals: Journal[];
  id: string;
  name: string;
  selected?: boolean | undefined;
};

enum IntegrationSlug {
  HORUS_CHIFT = 'horus-chift',
  OCTOPUS_CHIFT = 'octopus-chift',
  EXACT_CHIFT = 'exact-chift',
  PEPPOL = 'peppol',
  ODOO_CHIFT = 'odoo-chift',
}

enum ChiftIntegrationStatus {
  AUTHORIZATION_REQUIRED = 'authorization_required',
  AUTHORIZED = 'authorized',
  DISCONNECTED = 'disconnected',
  AVAILABLE = 'available',
  ACTIVE = 'active',
  WAITING_CALLBACK = 'waiting_callback',
}

type ChiftIntegrationType = {
  icon_url: string;
  integrationId: string;
  logo_url: string;
  slug: IntegrationSlug;
  status: ChiftIntegrationStatus | string;
  type: string;
  _id: string;
  isConnected?: boolean;
  metaData: {
    expenseVATCodes: any;
    revenueVATCodes: any;
  };
};

export {
  VatCode,
  Journal,
  FolderData,
  IntegrationSlug,
  ChiftIntegrationType,
  JournalTypes,
  ChiftIntegrationStatus,
};
